import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import { PersistGate } from 'redux-persist/integration/react';
import { persistedStore, store } from './redux/index.ts';
import * as Sentry from '@sentry/react';
import Loading from './components/Loading/index.tsx';

import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';

import './assets/css/index.css';

import { Sounds } from './utils/Music.ts';

Sentry.init({
  dsn: 'https://a5b1e4fc71822847e3bb0e4f3e5b7335@o4508750331248640.ingest.de.sentry.io/4508750333804624',
  integrations: [],
});

const App = React.lazy(() => import('./App'));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistedStore}>
          <Suspense fallback={<Loading />}>
            <App />
          </Suspense>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

const player = new Sounds();

export { player };
